import { render, staticRenderFns } from "./Steps.vue?vue&type=template&id=96a7d484&scoped=true"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"
import style0 from "./Steps.vue?vue&type=style&index=0&id=96a7d484&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a7d484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96a7d484')) {
      api.createRecord('96a7d484', component.options)
    } else {
      api.reload('96a7d484', component.options)
    }
    module.hot.accept("./Steps.vue?vue&type=template&id=96a7d484&scoped=true", function () {
      api.rerender('96a7d484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/Steps.vue"
export default component.exports